import React from 'react';
import ServicioItem from './ServicioItem';

/**
 * Componente para mostrar una lista de servicios con espaciado óptimo
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.servicios - Lista de servicios a mostrar
 * @param {Array} props.sucursales - Lista de sucursales disponibles
 * @param {Array} props.categorias - Lista de categorías disponibles
 * @param {function} props.onEdit - Función para editar un servicio
 * @param {function} props.onDelete - Función para eliminar un servicio
 * @returns {JSX.Element} - Componente de lista de servicios
 */
const ServiciosList = ({ servicios = [], sucursales = [], categorias = [], onEdit, onDelete }) => {
  if (servicios.length === 0) {
    return (
      <div className="text-center p-4 bg-gray-800 rounded text-gray-400">
        No hay servicios registrados. Agrega uno para comenzar.
      </div>
    );
  }

  return (
    <div>
      <ul className="mt-4 space-y-3">
        {servicios.map(servicio => (
          <ServicioItem
            key={servicio.id}
            servicio={servicio}
            sucursales={sucursales}
            categorias={categorias}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </ul>
    </div>
  );
};

export default ServiciosList;